export default function getDeviceType(userAgent) {
  // regex searches for mobile platforms
  const mobileDevice = /android|webos|iphone|ipad|ipod|blackberry|windows phone|iemobile|opera mini|mobile|crios/i;
  const device = mobileDevice.test(userAgent) ? 'mobile' : 'desktop';
  return device;
}
